<template>
  <ol class="step-indicator">
    <li
      v-for="step in steps" :key="step.id"
      is="step-navigation-step"
      :step="step"
      :currentstep="currentstep"
      @step-change="changeStep">
    </li>
  </ol>
</template>
<script>
  import StepNavigationStep from './step-navigation-step.vue'

  export default {
    props: ['steps', 'currentstep'],
    data() {
      return {
        indicatorclass: false
      }
    },
    components: {
      'step-navigation-step': StepNavigationStep
    },
    methods: {
      changeStep(step) {
        this.$emit('step-change', step)
      }
    }
  }
</script>
